import React, { useEffect, useState } from 'react';
import { Button } from '../components/ui/button';

interface Timecard {
  clock_in: string | null;
  clock_out: string | null;
}

interface InOutButtonDisplayProps {
  timecards: Timecard[] | null;
  onClockIn: () => void;
  onClockOut: () => void;
}

const InOutButtonDisplay: React.FC<InOutButtonDisplayProps> = ({ timecards, onClockIn, onClockOut }) => {
  const [clockInEnabled, setClockInEnabled] = useState(true);
  const [clockOutEnabled, setClockOutEnabled] = useState(false);

  useEffect(() => {
    if (timecards === null) {
      // If timecards is null, enable Clock In and disable Clock Out
      setClockInEnabled(true);
      setClockOutEnabled(false);
    } else if (timecards.length > 0) {
      const allCompletedOrEmpty = timecards.every(
        (session) => (session.clock_in && session.clock_out) || (!session.clock_in && !session.clock_out)
      );

      const anyIncompleteSession = timecards.some(
        (session) => session.clock_in && !session.clock_out
      );

      if (allCompletedOrEmpty) {
        // All sessions are either completed or empty, enable only Clock In
        setClockInEnabled(true);
        setClockOutEnabled(false);
      } else if (anyIncompleteSession) {
        // There is an incomplete session, enable only Clock Out
        setClockInEnabled(false);
        setClockOutEnabled(true);
      } else {
        // Default case, disable both if logic does not match any condition
        setClockInEnabled(false);
        setClockOutEnabled(false);
      }
    } else {
      // No work sessions, disable both buttons initially
      setClockInEnabled(false);
      setClockOutEnabled(false);
    }
  }, [timecards]);

  return (
    <div className="flex justify-center gap-3">
      <Button
        onClick={onClockIn}
        disabled={!clockInEnabled}
        size="medium"
        variant="default"
      >
        Clock In
      </Button>
      <Button
        onClick={onClockOut}
        disabled={!clockOutEnabled}
        size="medium"
        variant="inverted"
      >
        Clock Out
      </Button>
    </div>
  );
};

export default InOutButtonDisplay;